import { FilterOperator, LoanStatusExternal, MetricView } from '@nemuru-eng/js-api-client';

import { QueryBuilder } from '../QueryBuilder';
import { MetricFilter } from './MetricFilter';

export class LoanStatusExternalFilter extends MetricFilter<LoanStatusExternal> {
  public field = 'loan_status_external';
  public operator = FilterOperator.IN;

  constructor(loanStatusExternal?: LoanStatusExternal[]) {
    super(loanStatusExternal);
  }

  public needsRequest(newQueryBuilder: QueryBuilder): boolean {
    const newFilter = newQueryBuilder.metricFilter<LoanStatusExternalFilter>(this);
    if (this.areValuesIncluded(newFilter)) return false;
    return true;
  }

  public merge(newFilter: LoanStatusExternalFilter): this {
    if (!(newFilter instanceof LoanStatusExternalFilter)) return this;
    if (newFilter.values === undefined) return new LoanStatusExternalFilter(undefined) as this;
    if (this.areValuesIncluded(newFilter)) return this;
    const uniqueValues = Array.from(new Set([...this.values, ...newFilter.values]));
    return new LoanStatusExternalFilter(uniqueValues) as this;
  }

  public filterMetrics<K extends MetricView>(metrics: K[]): K[] {
    if (!this.values) return metrics;
    return metrics.map((metricView) => {
      const filteredMetricsByStatus = metricView.metrics.filter((metric) =>
        this.values.includes(metric.loanStatusExternal),
      );
      return { ...metricView, metrics: filteredMetricsByStatus };
    });
  }
}
